import { render, staticRenderFns } from "./SubmitTask.vue?vue&type=template&id=57cc055f&scoped=true"
import script from "./SubmitTask.vue?vue&type=script&lang=js"
export * from "./SubmitTask.vue?vue&type=script&lang=js"
import style0 from "./SubmitTask.vue?vue&type=style&index=0&id=57cc055f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cc055f",
  null
  
)

export default component.exports